import { Routes } from '@angular/router';
import { LeisureTravelComponent } from './leisure-travel.component';
import { XlLeisureTravelComponentType03 } from './xl-leisure-travel-type03/xl-leisure-travel-type03.component';

export default [
    {
        path     : '',
        component: LeisureTravelComponent,
    },
    {
        path     : 'holiday-travel',
        component: XlLeisureTravelComponentType03,
    },
    
] as Routes;
